/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddOrganizationRawMaterialAllergenRequest } from "../models/AddOrganizationRawMaterialAllergenRequest";
import type { AddOrganizationRawMaterialCompositionRequest } from "../models/AddOrganizationRawMaterialCompositionRequest";
import type { AddOrganizationRawMaterialImpurityRequest } from "../models/AddOrganizationRawMaterialImpurityRequest";
import type { Body_OrganizationRawMaterials_create_organization_raw_material_document } from "../models/Body_OrganizationRawMaterials_create_organization_raw_material_document";
import type { Body_OrganizationRawMaterials_replace_organization_raw_material_document } from "../models/Body_OrganizationRawMaterials_replace_organization_raw_material_document";
import type { BooleanResponse } from "../models/BooleanResponse";
import type { CreateOrganizationRawMaterialAttributeRequest } from "../models/CreateOrganizationRawMaterialAttributeRequest";
import type { CreateOrganizationRawMaterialRequest } from "../models/CreateOrganizationRawMaterialRequest";
import type { PaginatedResponse_list_definitions_public_v1_organization_raw_material_OrganizationRawMaterialListing__ } from "../models/PaginatedResponse_list_definitions_public_v1_organization_raw_material_OrganizationRawMaterialListing__";
import type { RawMaterialSearchRequest } from "../models/RawMaterialSearchRequest";
import type { Response_list_bool__ } from "../models/Response_list_bool__";
import type { Response_list_definitions_public_v1_organization_document_OrganizationDocument__ } from "../models/Response_list_definitions_public_v1_organization_document_OrganizationDocument__";
import type { Response_list_definitions_public_v1_organization_raw_material_RawMaterialSearchResult__ } from "../models/Response_list_definitions_public_v1_organization_raw_material_RawMaterialSearchResult__";
import type { Response_OrganizationRawMaterial_ } from "../models/Response_OrganizationRawMaterial_";
import type { Response_str_ } from "../models/Response_str_";
import type { Response_UUID_ } from "../models/Response_UUID_";
import type { SearchOrganizationRawMaterialsRequest } from "../models/SearchOrganizationRawMaterialsRequest";
import type { UpdateOrganizationDocumentRequest } from "../models/UpdateOrganizationDocumentRequest";
import type { UpdateOrganizationRawMaterialAllergensRequest } from "../models/UpdateOrganizationRawMaterialAllergensRequest";
import type { UpdateOrganizationRawMaterialAttributeRequest } from "../models/UpdateOrganizationRawMaterialAttributeRequest";
import type { UpdateOrganizationRawMaterialCompositionRequest } from "../models/UpdateOrganizationRawMaterialCompositionRequest";
import type { UpdateOrganizationRawMaterialImpuritiesRequest } from "../models/UpdateOrganizationRawMaterialImpuritiesRequest";
import type { UpdateOrganizationRawMaterialRequest } from "../models/UpdateOrganizationRawMaterialRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class OrganizationRawMaterialsService {
  /**
   * Create Organization Raw Material
   * @param organizationId
   * @param requestBody
   * @returns Response_UUID_ Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsCreateOrganizationRawMaterial(
    organizationId: string,
    requestBody: CreateOrganizationRawMaterialRequest
  ): CancelablePromise<Response_UUID_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/organization/{organization_id}/raw-materials",
      path: {
        organization_id: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Search Organization Raw Materials
   * @param organizationId
   * @param requestBody
   * @returns PaginatedResponse_list_definitions_public_v1_organization_raw_material_OrganizationRawMaterialListing__ Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsSearchOrganizationRawMaterials(
    organizationId: string,
    requestBody: SearchOrganizationRawMaterialsRequest
  ): CancelablePromise<PaginatedResponse_list_definitions_public_v1_organization_raw_material_OrganizationRawMaterialListing__> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/raw-materials",
      path: {
        organization_id: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Organization Raw Material
   * @param organizationId
   * @param organizationRawMaterialId
   * @returns Response_OrganizationRawMaterial_ Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsGetOrganizationRawMaterial(
    organizationId: string,
    organizationRawMaterialId: string
  ): CancelablePromise<Response_OrganizationRawMaterial_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Raw Material
   * @param organizationId
   * @param organizationRawMaterialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsUpdateOrganizationRawMaterial(
    organizationId: string,
    organizationRawMaterialId: string,
    requestBody: UpdateOrganizationRawMaterialRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Organization Raw Material Attribute
   * @param organizationId
   * @param organizationRawMaterialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsCreateOrganizationRawMaterialAttribute(
    organizationId: string,
    organizationRawMaterialId: string,
    requestBody: CreateOrganizationRawMaterialAttributeRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/attributes",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Raw Material Attribute
   * @param organizationId
   * @param organizationRawMaterialId
   * @param attributeId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsUpdateOrganizationRawMaterialAttribute(
    organizationId: string,
    organizationRawMaterialId: string,
    attributeId: string,
    requestBody: UpdateOrganizationRawMaterialAttributeRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/attributes/{attribute_id}",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
        attribute_id: attributeId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Organization Raw Material Document
   * @param organizationId
   * @param organizationRawMaterialId
   * @param formData
   * @returns Response_list_bool__ Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsCreateOrganizationRawMaterialDocument(
    organizationId: string,
    organizationRawMaterialId: string,
    formData: Body_OrganizationRawMaterials_create_organization_raw_material_document
  ): CancelablePromise<Response_list_bool__> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/documents",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Replace Organization Raw Material Document
   * @param organizationId
   * @param organizationRawMaterialId
   * @param organizationDocumentId
   * @param formData
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsReplaceOrganizationRawMaterialDocument(
    organizationId: string,
    organizationRawMaterialId: string,
    organizationDocumentId: string,
    formData: Body_OrganizationRawMaterials_replace_organization_raw_material_document
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/documents/{organization_document_id}/replace",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
        organization_document_id: organizationDocumentId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Organization Document
   * @param organizationId
   * @param organizationDocumentId
   * @returns Response_str_ Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsGetOrganizationDocument(
    organizationId: string,
    organizationDocumentId: string
  ): CancelablePromise<Response_str_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/documents/{organization_document_id}",
      path: {
        organization_id: organizationId,
        organization_document_id: organizationDocumentId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Document
   * @param organizationId
   * @param organizationDocumentId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsUpdateOrganizationDocument(
    organizationId: string,
    organizationDocumentId: string,
    requestBody: UpdateOrganizationDocumentRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/documents/{organization_document_id}",
      path: {
        organization_id: organizationId,
        organization_document_id: organizationDocumentId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Organization Document History
   * @param organizationId
   * @param organizationDocumentId
   * @returns Response_list_definitions_public_v1_organization_document_OrganizationDocument__ Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsGetOrganizationDocumentHistory(
    organizationId: string,
    organizationDocumentId: string
  ): CancelablePromise<Response_list_definitions_public_v1_organization_document_OrganizationDocument__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/documents/{organization_document_id}/history",
      path: {
        organization_id: organizationId,
        organization_document_id: organizationDocumentId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Organization Raw Material Progress
   * @param organizationId
   * @param organizationRawMaterialId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsGetOrganizationRawMaterialProgress(
    organizationId: string,
    organizationRawMaterialId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/progress",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Organization Raw Material Composition
   * @param organizationId
   * @param organizationRawMaterialId
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsAddOrganizationRawMaterialComposition(
    organizationId: string,
    organizationRawMaterialId: string,
    requestBody: AddOrganizationRawMaterialCompositionRequest
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/composition",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Raw Material Composition
   * @param organizationId
   * @param organizationRawMaterialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsUpdateOrganizationRawMaterialComposition(
    organizationId: string,
    organizationRawMaterialId: string,
    requestBody: UpdateOrganizationRawMaterialCompositionRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/composition",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Organization Raw Material Composition
   * @param organizationId
   * @param organizationRawMaterialId
   * @param compositionId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsDeleteOrganizationRawMaterialComposition(
    organizationId: string,
    organizationRawMaterialId: string,
    compositionId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/composition/{composition_id}",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
        composition_id: compositionId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Organization Raw Material Allergen
   * @param organizationId
   * @param organizationRawMaterialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsAddOrganizationRawMaterialAllergen(
    organizationId: string,
    organizationRawMaterialId: string,
    requestBody: AddOrganizationRawMaterialAllergenRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/allergens",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Raw Material Allergens
   * @param organizationId
   * @param organizationRawMaterialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsUpdateOrganizationRawMaterialAllergens(
    organizationId: string,
    organizationRawMaterialId: string,
    requestBody: UpdateOrganizationRawMaterialAllergensRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/allergens",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Organization Raw Material Allergen
   * @param organizationId
   * @param organizationRawMaterialId
   * @param allergenId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsDeleteOrganizationRawMaterialAllergen(
    organizationId: string,
    organizationRawMaterialId: string,
    allergenId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/allergens/{allergen_id}",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
        allergen_id: allergenId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Organization Raw Material Impurity
   * @param organizationId
   * @param organizationRawMaterialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsAddOrganizationRawMaterialImpurity(
    organizationId: string,
    organizationRawMaterialId: string,
    requestBody: AddOrganizationRawMaterialImpurityRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/impurities",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Raw Material Impurities
   * @param organizationId
   * @param organizationRawMaterialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsUpdateOrganizationRawMaterialImpurities(
    organizationId: string,
    organizationRawMaterialId: string,
    requestBody: UpdateOrganizationRawMaterialImpuritiesRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/impurities",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Organization Raw Material Impurity
   * @param organizationId
   * @param organizationRawMaterialId
   * @param impurityId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsDeleteOrganizationRawMaterialImpurity(
    organizationId: string,
    organizationRawMaterialId: string,
    impurityId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/organization/{organization_id}/raw-materials/{organization_raw_material_id}/impurities/{impurity_id}",
      path: {
        organization_id: organizationId,
        organization_raw_material_id: organizationRawMaterialId,
        impurity_id: impurityId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Search All Raw Materials
   * @param organizationId
   * @param requestBody
   * @returns Response_list_definitions_public_v1_organization_raw_material_RawMaterialSearchResult__ Successful Response
   * @throws ApiError
   */
  public static organizationRawMaterialsSearchAllRawMaterials(
    organizationId: string,
    requestBody: RawMaterialSearchRequest
  ): CancelablePromise<Response_list_definitions_public_v1_organization_raw_material_RawMaterialSearchResult__> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/raw-materials/search",
      path: {
        organization_id: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
